import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import {inject, Injectable} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {finalize, Observable, throwError} from "rxjs";
import {catchError} from "rxjs/operators";
import {ErrorDialogComponent} from "../dialogs/error-dialog/error-dialog.component";
import {LoadingService} from "./service/loading.service";
import {environment} from "../../environments/environment";

export const SkipLoadingAndError =
  new HttpContextToken<boolean>(() => false);

@Injectable()
export class LoadingAndErrorInterceptor implements HttpInterceptor {
  private loadingService = inject(LoadingService);

  private dialog = inject(MatDialog);

  intercept<T>(
    req: HttpRequest<T>,
    next: HttpHandler
  ): Observable<HttpEvent<T>> {
    if (req.context.get(SkipLoadingAndError)) {
      return next.handle(req);
    }

    this.loadingService.loadingOn();

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        this.loadingService.loadingOff();

        if (req.url.startsWith(environment.issuer)) {
          return next.handle(req);
        }

        console.error('HTTP error occurred:', error);

        if (error.status != 404)
          this.openErrorDialog('errors.unexpected_error.message');

        return throwError(() => error);
      }),
      finalize(() => {
        this.loadingService.loadingOff();
      })
    );
  }

  private openErrorDialog(message: string) {
    this.dialog.open(ErrorDialogComponent, {
      data: { message }
    });
  }
}
